export default __webpack_public_path__ + "forward-button.png";